import React from 'react';
import { Alert, Empty, Select, Spin, Tag, Typography } from 'antd';

interface ReusableSelectProps {
  isLoading: boolean;
  availableOptions: any[];
  selectedOptions: any[];
  canAddNewItem: boolean;
  allOptionsByIds: { [key: string]: any };
  searchTerm: string;
  onSearch: (value: string) => void;
  value: any[];
  onChange: (value: any[]) => void;
  onBlur?: React.FocusEventHandler<HTMLElement>;
  searchTermError: string | null;
  dropdownWarning?: string | null;
  placeholder: string;
  newItemLabel: string;
  notFoundContentDescription: string;
  showNewItem: boolean;
  invalidItemIds?: string[];
}

const MobileSelection: React.FC<ReusableSelectProps> = ({
  isLoading,
  availableOptions,
  selectedOptions,
  canAddNewItem,
  allOptionsByIds,
  searchTerm,
  onSearch,
  value,
  onChange,
  onBlur,
  searchTermError,
  dropdownWarning,
  placeholder,
  newItemLabel,
  notFoundContentDescription,
  showNewItem,
  invalidItemIds = [],
}) => {
  return (
    <Select
      size="large"
      allowClear={true}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      mode="multiple"
      options={availableOptions}
      onSearch={onSearch}
      searchValue={searchTerm}
      placeholder={placeholder}
      optionRender={(option) => {
        const optionValue = option.value;

        if (!optionValue) {
          return <></>;
        }

        const type = allOptionsByIds[optionValue]?.type;

        return (
          <>
            {allOptionsByIds[optionValue]?.label}
            {type === 'new-group' && (
              <Tag color="green" style={{ marginRight: 0, marginLeft: 4 }}>
                {newItemLabel}
              </Tag>
            )}
          </>
        );
      }}
      filterOption={() => true}
      dropdownRender={(menu) => (
        <>
          {dropdownWarning && (
            <Alert
              style={{
                margin: 12,
                marginBottom: 16,
                marginTop: 12,
              }}
              message={dropdownWarning}
              type="warning"
            />
          )}
          {searchTermError && (
            <Alert
              style={{
                margin: 12,
                marginBottom: 16,
                marginTop: 12,
              }}
              message={searchTermError}
              type="warning"
            />
          )}
          {canAddNewItem && !searchTerm && showNewItem && (
            <Alert
              style={{
                margin: 12,
                marginBottom: 16,
                marginTop: 12,
              }}
              message={`Start typing to create a new group.`}
              type="info"
            />
          )}
          {menu}
        </>
      )}
      notFoundContent={
        isLoading ? (
          <Spin size="small" />
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={notFoundContentDescription}
          />
        )
      }
      loading={isLoading}
      tagRender={(props) => {
        const { label, value } = props;
        const type = allOptionsByIds[value]?.type;

        if (showNewItem && type === 'new-group') {
          return (
            <span
              style={{
                marginTop: 2,
                marginBottom: 2,
                paddingRight: 8,
              }}
            >
              <Typography.Text style={{ fontSize: 16 }}>
                {label}
              </Typography.Text>
              {!invalidItemIds.includes(value) && (
                <Tag color="green" style={{ marginRight: 0, marginLeft: 4 }}>
                  {newItemLabel}
                </Tag>
              )}
              <Typography.Text
                disabled
                style={{ fontSize: 16, paddingLeft: 8 }}
              >
                /
              </Typography.Text>
            </span>
          );
        }

        return (
          <span
            style={{
              verticalAlign: 'middle',
              marginTop: 2,
              marginBottom: 2,
              paddingLeft: selectedOptions[0]?.value === value ? 8 : 0,
              paddingRight: 8,
            }}
          >
            <Typography.Text
              style={{
                fontSize: 16,
              }}
            >
              {label}
            </Typography.Text>
            <Typography.Text disabled style={{ fontSize: 16, paddingLeft: 8 }}>
              /
            </Typography.Text>
          </span>
        );
      }}
    />
  );
};

export default MobileSelection;
